import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';//Link
import { useDispatch, useSelector } from 'react-redux';
import leftArrow from '../../assets/arrow_back.svg';
import AdminError from '../../components/admin/admin-error';
import Navigation from '../../components/navigation/Navigation';
import HeaderProfile from "../../components/HeaderProfile";
import PortalAlert from '../../components/portalAlert/portalAlert';
import AdminTextInput from '../../components/admin/admin-text-input.js';
import MediaUploader from '../../components/multipleMedia/MediaUploader.js';
import { marketPlaceItem } from '../admin/MarketPlace/marketPlaceItem';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { showLoading, hideLoading } from '../../store/loading-reducer';
import { submitMyMarketPlaceList, getMarketPlaceByIdEdit } from '../../api/marketPlace';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { useAdminMenuContext } from "../../context/AdminMenuContext";
import { getMarketPlaceTypes } from '../../store/marketPlace/actions';
import { Scrollbar } from 'react-scrollbars-custom';
import { ViewPageModal } from '../../components/ViewPageModal/ViewPageModal';

const ckEditorConfig = {
    toolbar: [
        'Bold',
        'Italic',
        'Link',
        'Unlink',
        'NumberedList',
        'BulletedList',
        'doclibrary'
    ],
    link: {
        decorators: {
            openInNewTab: {
                mode: 'manual',
                label: 'Open in a new tab',
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            },
        },
        addTargetToExternalLinks: true,
        defaultProtocol: 'http://',
        validate: function (url) {

            return /^(?:(?:https?|ftp):\/\/)?(?:\/)?(?:[^@\n]+@)?(?:www\.)?[^.]+\.[^.]+/.test(url);
        },
    },
    image: {
        resizeOptions: false,
        toolbar: []
    }
};

const FileRepository = {
    createUploadAdapter: (loader) => {
        return new UploadAdapter(loader);
    },
};
class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    upload() {
        return new Promise((resolve) => {
            const imageUrl = this.loader.data;
            resolve({ default: imageUrl });
        });
    }
}

export default function AddEditMyMarketPlaceList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const { marketPlaceTypesList } = useSelector(state => state.marketPlace);
    const [marketPlace, setMarketPlace] = useState(marketPlaceItem);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [mediaItems, setMediaItems] = useState([]);
    const { marketplaceBaseId } = useParams();
    const [publishDateInputValue, setPublishDateInputValue] = useState(marketPlace?.publishDate ? new Date(marketPlace.publishDate) : new Date());
    const [editLink, setEditLink] = useAdminMenuContext('');
    const [modalOpen, setModalOpen] = useState(false);
    const [baseId, setBaseId] = useState(0);
    useEffect(() => {
        if (marketplaceBaseId > 0) {
            dispatch(showLoading());
            getMarketPlaceByIdEdit(marketplaceBaseId).then((response) => {
                let marketPlaceResponse = response.data.data;
                if (marketPlaceResponse?.amountType?.length > 23) {
                    marketPlaceResponse.amountType = marketPlaceResponse.amountType.substring(0, 23);
                }
                setMarketPlace(marketPlaceResponse);
                setPublishDateInputValue(marketPlaceResponse?.publishDate ? new Date(marketPlaceResponse.publishDate) : new Date());
                if (marketPlaceResponse.media !== null && marketPlaceResponse.media.length > 0) {
                    var getMediaItems = [];
                    marketPlaceResponse.media.forEach((item) => {
                        item.mediaItem.mediaId = item.mediaId;
                        getMediaItems.push(item.mediaItem);
                    });
                    setMediaItems(getMediaItems);
                }
                setEditLink(`/marketplace-details/${marketplaceBaseId}`);
                console.log(editLink)
            }).catch((error) => {
                console.error("Error fetching marketplace:", error);
            }).finally(() => {
                dispatch(hideLoading());
            });
        }
        else {
            setEditLink('');
        }

    }, []);


    const [validation, setValidation] = useState({
        marketPlaceTitle: true,
        marketPlaceAuthor: true,
        marketPlaceType: true
    });

    useEffect(() => {
        document.title = 'Market Place  | CWP Employee Portal';
        dispatch(getMarketPlaceTypes());
    }, []);

    const handleMarketPlaceSave = () => {
        dispatch(showLoading());
        var isValid = true;

        let validate = {
            marketPlaceTitleError: '',
            marketPlaceTypeError: '',
            marketPlaceAuthorError: '',

        };
        if (marketPlace == null || marketPlace?.title == null || marketPlace?.title == "") {
            validate.marketPlaceTitle = false;
            validate.marketPlaceTitleError = "Title is required";
            isValid = false;
        }
        if (marketPlace == null || marketPlace?.author == null || marketPlace?.author == "") {
            validate.marketPlaceAuthor = false;
            validate.marketPlaceAuthorError = "Author is required";
            isValid = false;
        }
        if (!marketPlace?.marketPlaceTypeId || marketPlace?.marketPlaceTypeId === 0) {
            validate.marketPlaceType = false;
            validate.marketPlaceTypeError = "Type is required";
            isValid = false;
        }

        setValidation({ ...validation, ...validate });
        if (isValid == false) {
            dispatch(hideLoading());
            return;
        }
        submitMyMarketPlaceList(marketPlace)
            .then((response) => {
                if (response.data.success == false) {
                    dispatch(hideLoading());
                    setError(response.data.message);
                    return;
                }
                if (response.data.success) {
                    setMarketPlace({ ...marketPlace, id: response?.data?.data?.id, baseId: response?.data?.data?.baseId })
                    dispatch(hideLoading());
                    setBaseId(response?.data?.data?.baseId)
                    setModalOpen(true);
                }
            })
            .catch((err) => {
                dispatch(hideLoading());
                if (err.response.data && err.response.data.message) {
                    setError(err.response.data.message);
                } else {
                    setError(err.response.responseText);
                }
            });
    };

    const handleMediaUpdates = (mediaItems) => {
        setMarketPlace({
            ...marketPlace,
            media: mediaItems,
        });
    };


    const handleDateFormate = (date) => {
        const inputDate = date;
        let formattedDate = inputDate.replace(/\D/g, ''); // Remove all non-digit characters
        if (formattedDate.length > 2 && formattedDate.length <= 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2);
        } else if (formattedDate.length > 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2, 4) + '/' + formattedDate.slice(4, 8);
        }
        return formattedDate;
    };

    const isValidDateFormat = (dateString) => {
        // Define a regular expression pattern for the desired format (mm/dd/yyyy)
        const dateFormatPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

        // Check if the dateString matches the pattern
        return dateFormatPattern.test(dateString);
    }

    const publishDateDateChange = (event) => {
        if (event.type === "change") {
            const formattedDate = handleDateFormate(event.target.value);
            setPublishDateInputValue(formattedDate);
            if (isValidDateFormat(formattedDate)) {
                setMarketPlace({ ...marketPlace, publishDate: new Date(formattedDate) });
            }
        }
    };

    const handlePaste = (event, editor, data) => {
        event.stop();

        // Get plain text from clipboard
        const plainText = data.dataTransfer.getData('text/plain');

        // Insert plain text at the current selection/cursor
        editor.model.change((writer) => {
            // Remove any selection and insert plain text
            writer.insertText(plainText, editor.model.document.selection.getFirstPosition());
        });

        // Update your state with the new content (plain text)
        const updatedContent = editor.getData();

        setMarketPlace((prevEvent) => ({ ...prevEvent, content: updatedContent }));
        setIsInitialLoad(false);
    };
    const handleMarketPlaceType = (e) => {
        const selectedType = parseInt(e.target.value);
        setMarketPlace({ ...marketPlace, marketPlaceTypeId: selectedType });
    };
    const [isOpen, setIsOpen] = useState(false);

    // Close on Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setIsOpen(false);
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <>
            <ViewPageModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                onViewPage={() => window.open(`/marketplace-details/${baseId}`, '_blank')}
                onBackToList={() => navigate('/marketplacemylisting')}
                message={`Listing has been successfully ${marketPlace?.baseId > 0 ? "Updated" : "Added"}`}
            />
            <div className="directory-wrap news-wrap">
                <div className="drawer-menu-collapse-wrap"></div>
                <Navigation />
                <div className="events-page-wrap marketplace-page-wrap marketplace-mylisting-edit-wrap">
                    <div className="page-inner events-inner marketplace-inner">
                        <div className="profile-wrap-outer mobile-show">
                            <HeaderProfile />
                        </div>

                        <div className="events-content-scrollable-wrap">
                            <div className="inner-pages-alert">
                                <PortalAlert />
                            </div>
                            <div className="profile-wrap-outer">
                                <HeaderProfile />
                            </div>
                            <div className="events-header-wrap marketplace-header-wrap">
                                <div className="marketplace-column-wrap inline-tags back-tag-wrap">
                                    <div className="arrow-header-inline" onClick={() => navigate('/marketplacemylisting')}>
                                        <img src={leftArrow} alt="left arrow" className="left-arrow" loading="lazy" />
                                        <span>Back to Marketplace</span>
                                    </div>
                                </div>
                                <AdminError
                                    message={error}
                                    onClose={() => {
                                        setError('');
                                    }}
                                ></AdminError>
                                <div className="admin-section admin-section-narrow">
                                    <div className="admin-section-row">
                                        <div className="admin-section-cell">
                                            <label className="admin-radio-label inline label-nowrap" style={{ color: '#a4a4a4' }}>
                                                <input
                                                    className="admin-inline-checkbox "
                                                    type="radio"
                                                    id="Publish"
                                                    name="visibility"
                                                    checked={marketPlace?.visibility === 0}
                                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 0 })}
                                                />
                                                Publish
                                            </label>
                                        </div>
                                        <div className="admin-section-cell">
                                            <label className="admin-radio-label inline" style={{ color: '#a4a4a4' }}>
                                                <input
                                                    className="admin-inline-checkbox"
                                                    type="radio"
                                                    id="Unpublish"
                                                    name="visibility"
                                                    checked={marketPlace?.visibility === 2}
                                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 2 })}
                                                />
                                                Unpublish
                                            </label>
                                        </div>
                                        <div className="admin-section-cell">
                                            <label className="admin-radio-label inline label-nowrap" style={{ color: '#a4a4a4' }}>
                                                <input
                                                    className="admin-inline-checkbox"
                                                    type="radio"
                                                    id="Sold"
                                                    name="visibility"
                                                    checked={marketPlace?.visibility === 3}
                                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 3 })}
                                                />
                                                Sold
                                            </label>
                                        </div>
                                    </div>

                                    <div className="admin-section-row">
                                        <div className="admin-section-cell wide">
                                            <AdminTextInput
                                                label="Title"
                                                style={{ color: '#a4a4a4' }}
                                                id="title-marketplace"
                                                value={marketPlace?.title ?? ''}
                                                isRequired={true}
                                                onChange={(value) => {
                                                    setMarketPlace({ ...marketPlace, title: value });
                                                    setValidation({ ...validation, marketPlaceTitle: value != '' });
                                                }}
                                                validated={validation?.marketPlaceTitle}
                                                requiredText={validation?.marketPlaceTitleError}
                                            />
                                        </div>
                                    </div>
                                    <div className="admin-section-row">
                                        <div className={`admin-section-cell wide ${!validation?.marketPlaceType ? 'input-validation-error' : ''}`}>
                                            <label className="admin-default-label">
                                                Type
                                            </label>
                                            <select className="admin-default-select" onChange={handleMarketPlaceType} value={marketPlace?.marketPlaceTypeId}>
                                                <option value="0" disabled hidden > Please Select a Type </option>
                                                {marketPlaceTypesList
                                                    .map((marketPlaceType) =>
                                                        <option key={marketPlaceType.id} value={marketPlaceType.id}>
                                                            {marketPlaceType.name}
                                                        </option>
                                                    )
                                                }
                                            </select>

                                            {!validation?.marketPlaceType && (
                                                <p className="input-validation-error"><span className="validation-error-message">{validation?.marketPlaceTypeError}</span></p>
                                            )}
                                        </div>
                                        <div className="admin-section-cell wide">
                                            <AdminTextInput
                                                label="Author"
                                                id="author-marketplace"
                                                value={marketPlace?.author ?? ''}
                                                isRequired={true}
                                                onChange={(value) => {
                                                    setMarketPlace({ ...marketPlace, author: value });
                                                    setValidation({ ...validation, marketPlaceAuthor: value != '' });
                                                }}
                                                validated={validation.marketPlaceAuthor}
                                                requiredText={validation.marketPlaceAuthorError}
                                            />
                                        </div>
                                    </div>
                                    <div className="admin-section-row">
                                        <div className="admin-section-cell wide">
                                            <AdminTextInput
                                                label="Amount Bold Text"
                                                id="AmountInfo-marketplace"
                                                value={marketPlace?.amountInfo ?? ''}
                                                onChange={(value) => {
                                                    setMarketPlace({ ...marketPlace, amountInfo: value });

                                                }}
                                            />
                                        </div>
                                        <div className="admin-section-cell wide">
                                            <AdminTextInput
                                                label="Detail Sub Heading"
                                                id="detail-subheading-marketplace"
                                                value={marketPlace?.amountType ?? ''}
                                                onChange={(value) => {
                                                    if (value.length <= 23) {
                                                        setMarketPlace({ ...marketPlace, amountType: value });
                                                    }
                                                }}
                                            />
                                            <span className={`character-counter`}> {23 - (marketPlace?.amountType?.length ?? 0)}/23 characters remaining </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="admin-section-row">
                                            <div className="admin-section-cell wide">
                                                <AdminTextInput
                                                    label="Location"
                                                    id="location-marketplace"
                                                    value={marketPlace?.location ?? ''}
                                                    onChange={(value) => {
                                                        setMarketPlace({ ...marketPlace, location: value });

                                                    }}
                                                />
                                            </div>
                                            <div className="admin-section-cell wide">
                                                <label className="admin-default-label">Publish Date</label>
                                                <DatePicker
                                                    className="admin-default-input-text"
                                                    selected={marketPlace?.publishDate ? new Date(marketPlace.publishDate) : new Date()}
                                                    placeholder="mm/dd/yyyy"
                                                    autoComplete="off"
                                                    onChange={(date) => {
                                                        setMarketPlace({ ...marketPlace, publishDate: date });
                                                    }}
                                                    onChangeRaw={publishDateDateChange}
                                                    value={publishDateInputValue}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="admin-section-row circle">
                                        <div className="admin-section-cell full">
                                            <p className="admin-section-small-headline">Image/Video</p>
                                            <div className="admin-section-gallery-wrapper">
                                                <MediaUploader
                                                    isPlaceHolder={false}
                                                    requireAltText={false}
                                                    imageOnly={false}
                                                    videoOnly={false}
                                                    forceCrop={false}
                                                    allowGallery={true}
                                                    mediaItems={mediaItems}
                                                    saveMediaItems={handleMediaUpdates}
                                                    allowSorting={true}
                                                    sortInTable="MarketPlaceMedia"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="admin-section-row">
                                        <div
                                            className={
                                                'admin-section-cell extra-wide'
                                            }
                                        >
                                            <label className="admin-default-label" htmlFor="short-desc">
                                                Content
                                            </label>
                                            <CKEditor
                                                editor={Editor}
                                                config={ckEditorConfig}
                                                data={marketPlace && marketPlace.content || ''}
                                                onReady={(editor) => {
                                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
                                                        FileRepository.createUploadAdapter(loader);

                                                    // Listen for the clipboardInput event to intercept paste
                                                    editor.editing.view.document.on('clipboardInput', (evt, data) => {
                                                        handlePaste(evt, editor, data);
                                                    });
                                                }}
                                                onChange={(marketPlace, editor) => {
                                                    const data = editor.getData();
                                                    setMarketPlace((prevMarketPlace) => ({ ...prevMarketPlace, content: data }));
                                                    if (!isInitialLoad) {
                                                        console.log("data", data);
                                                    }
                                                    setIsInitialLoad(false);
                                                }}
                                                onPaste={handlePaste}
                                            />
                                        </div>
                                    </div>

                                    <div className="admin-section-row">
                                        <div className="admin-section-cell wide">
                                            <label className="admin-default-label" htmlFor="WaterMark-marketplace">WaterMark</label>
                                            <textarea
                                                className="admin-default-textarea "
                                                id="WaterMark-marketplace"
                                                value={marketPlace?.waterMark ?? ''}
                                                onChange={(e) => {
                                                    setMarketPlace({ ...marketPlace, waterMark: e.target.value });
                                                }}
                                                rows="2"
                                                placeholder="Call or Text at (888)-888-8888"
                                            />
                                        </div>
                                    </div>
                                    <div className="admin-section-row">
                                        <div className="admin-section-cell wide">
                                            <button className="underline-button" onClick={() => setIsOpen(true)}>Rules of Conduct</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="admin-floating-button-wrap">
                                    <button
                                        className="admin-floating-button"
                                        onClick={() =>
                                            navigate('/marketplacemylisting')
                                        }
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="admin-floating-button power"
                                        onClick={handleMarketPlaceSave}
                                    >
                                        Save Changes
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {isOpen && (

                    <div
                        className="rule-conduct-overlay"
                        onClick={() => setIsOpen(false)} // Close when clicking outside
                    >


                        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                            <div className="popup-close-wrap">
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="popup-close"
                                >
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.00036 5.79037L1.19553 9.59518C1.09169 9.69903 0.961168 9.75215 0.803956 9.75455C0.646756 9.75697 0.513831 9.70384 0.405181 9.59518C0.296519 9.48653 0.242188 9.3548 0.242188 9.2C0.242188 9.04521 0.296519 8.91348 0.405181 8.80483L4.20999 5L0.405181 1.19518C0.301331 1.09134 0.248206 0.960818 0.245806 0.803605C0.243394 0.646405 0.296519 0.51348 0.405181 0.40483C0.513831 0.296168 0.645556 0.241837 0.800356 0.241837C0.955156 0.241837 1.08688 0.296168 1.19553 0.40483L5.00036 4.20964L8.80518 0.40483C8.90902 0.30098 9.03954 0.247855 9.19675 0.245455C9.35395 0.243043 9.48688 0.296168 9.59553 0.40483C9.70419 0.51348 9.75852 0.645205 9.75852 0.800005C9.75852 0.954805 9.70419 1.08653 9.59553 1.19518L5.79072 5L9.59553 8.80483C9.69938 8.90867 9.7525 9.03919 9.7549 9.19641C9.75732 9.35361 9.70419 9.48653 9.59553 9.59518C9.48688 9.70384 9.35515 9.75817 9.20035 9.75817C9.04555 9.75817 8.91383 9.70384 8.80518 9.59518L5.00036 5.79037Z" fill="currentColor" />
                                    </svg>
                                </button>
                            </div>
                            <Scrollbar
                                wrapperProps={{ className: 'custom-scrollbar-wrapper' }}
                                thumbMinSize={30}
                                trackYProps={{ className: 'custom-scrollbar-track-y' }}
                                thumbYProps={{ className: 'custom-scrollbar-thumb-y' }}
                            >
                                <h2 className="popup-window-headline">Marketplace Rules of Conduct</h2>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Respectful Behavior</p>
                                    <ul className="popup-content-item-list">
                                        <li>All users must treat others with respect, fairness, and courtesy.</li>
                                        <li>Harassment, discrimination, hate speech, and any offensive behavior will not be tolerated.</li>
                                        <li>Any form of abusive language or behavior that disrupts the community will result in suspension or banning from the platform.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Accurate Listings</p>
                                    <ul className="popup-content-item-list">
                                        <li>Sellers must ensure that all product listings are accurate, truthful, and not misleading in any way.</li>
                                        <li>Any claims about the product must be substantiated with verifiable information.</li>
                                        <li>No false advertising or misrepresentation of products or services.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Intellectual Property</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must respect intellectual property rights. Do not list, sell, or share counterfeit, pirated, or stolen goods.</li>
                                        <li>Only list products you have the right to sell, and ensure that all content (including photos, descriptions, and brand names) is your own or properly licensed.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Fair Transactions</p>
                                    <ul className="popup-content-item-list">
                                        <li>Buyers and sellers must honor all agreements, including prices, delivery dates, and payment methods.</li>
                                        <li>All payments should be made through the platform&apos;s official channels to ensure protection and proper documentation.</li>
                                        <li>Any attempt to circumvent the platform&apos;s payment system is strictly prohibited.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Prohibited Items</p>
                                    <ul className="popup-content-item-list">
                                        <li>The sale or trade of illegal, harmful, dangerous, or prohibited items is not allowed.</li>
                                        <li>This includes, but is not limited to, weapons, drugs, counterfeit goods, and stolen merchandise.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Privacy and Confidentiality</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must not share personal information of other users without consent.</li>
                                        <li>Respect the privacy of all participants, and ensure that any communication is appropriate for the marketplace environment.</li>
                                        <li>Do not attempt to collect or misuse personal data.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Product Quality and Refunds</p>
                                    <ul className="popup-content-item-list">
                                        <li>Sellers must offer goods in the condition described in their listings and comply with any guarantees or warranties offered.</li>
                                        <li>Buyers have the right to request refunds or returns in accordance with the marketplace&apos;s return policy if the product does not meet the description or is defective.</li>
                                        <li>Both buyers and sellers must engage in good faith when resolving disputes.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">No Fraudulent Activity</p>
                                    <ul className="popup-content-item-list">
                                        <li>Fraudulent activities, including scam listings, fake reviews, chargebacks, or any kind of deceptive behavior, will result in immediate account suspension and potential legal action.</li>
                                        <li>Sellers must not manipulate ratings or feedback systems.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Communication</p>
                                    <ul className="popup-content-item-list">
                                        <li>Communication between buyers and sellers should be polite and professional.</li>
                                        <li>Refrain from spamming other users or sending unsolicited messages.</li>
                                        <li>Use the platform&apos;s messaging system for all communications related to transactions.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Compliance with Local Laws</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must comply with all applicable local, state, and international laws, including import/export regulations, consumer protection laws, and tax requirements.</li>
                                        <li>Sellers are responsible for understanding the legalities of shipping items to different regions or countries.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Account Security</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users are responsible for the security of their accounts and must keep login credentials confidential.</li>
                                        <li>Report any suspicious activity or unauthorized transactions immediately to the platform administrators.</li>
                                        <li>It is recommended to use strong passwords and enable two-factor authentication when available.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Platform Integrity</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users are prohibited from attempting to exploit, hack, or disrupt the functionality of the platform in any way.</li>
                                        <li>Any manipulation of the marketplace algorithms, including attempting to artificially inflate product rankings, is forbidden.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Enforcement</p>
                                    <ul className="popup-content-item-list">
                                        <li>The platform reserves the right to take action, including warnings, suspension, or permanent bans, for violations of these rules.</li>
                                        <li>Serious violations, including fraud, illegal activity, or abusive behavior, may result in legal action.</li>
                                    </ul>
                                </div>

                            </Scrollbar>

                        </div>

                    </div>

                )}
            </div>
        </>
    );
}